import { TField } from './isField';
import { TFieldInput } from './isFieldInput';

export function getFieldName(
	field?: Pick<TField | TFieldInput, 'name'> | null
): string {
	return field?.name || '';
}
